// extracted by mini-css-extract-plugin
module.exports = {"fixedHeader":"Header_fixedHeader__3uZFi"};